module.exports = __webpack_public_path__ + "img/training.963f10e9.png";